<template>
  <div>
    <div v-if="isConnected && billTotal > 0">
      <vue-stripe-checkout
        ref="checkoutRef"
        :image="image"
        :name="name"
        :description="description"
        :currency="currency"
        :amount="amount"
        :allow-remember-me="false"
        @done="done"
      />
      <b-button
        class="stripe-payment-trigger"
        :disabled="disabled"
        @click="checkout"
      >
        Pay With Card
      </b-button>

    </div>
    <span id="payment-disabled" v-else>
      <b-button class="stripe-payment-trigger" disabled>Pay With Card</b-button>
      <b-tooltip
        v-if="!isConnected"
        target="payment-disabled"
        placement="top"
        title="Cannot charge without internet connection"
      />
      <b-tooltip
        v-if="billTotal <= 0"
        target="payment-disabled"
        placement="top"
        title="Total charge must be greater than zero"
      />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentButton',

  props: {
    billTotal: {
      type: Number,
      required: true,
      default: 0
    },
    chargeDescription: {
      type: String,
      required: false,
      default: null
    },
    chargeCallback: {
      type: Function,
      rqeuired: false,
      default: null
    },
    payer: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      image: require('@/assets/images/p-logo.jpg'),
      name: 'Pitaya Technologies',
      description: this.chargeDescription || 'Pay through stripe',
      currency: 'USD'
    };
  },

  computed: {
    amount: function() {
      return +this.billTotal * 100;
    },

    ...mapGetters([
      'getVendor',
      'isConnected'
    ])
  },

  methods: {
    async checkout() {
      const { token, args } = await this.$refs.checkoutRef.open();
    },

    done({ token, args }) {
      const paymentInfo = {
        token: token.id,
        vendor_id: this.getVendor.id,
        currency: this.currency,
        amount: this.amount,
        description: this.description,
        guest_name: this.payer
      };

      this.$emit('charge', paymentInfo);
    }
  }
};
</script>
